import { fetchData } from '../utils/netUtils';

const { pass } = window.__TBX_ENV__;

class CloudpassService {
  apiURL: string;
  cpShortName: string;

  /**
   * constructor to pay service instance
   * @param clientShortName - Cloudpass client shortName to use
   */
  constructor(cpShortName: string) {
    this.apiURL = pass.baseURL;
    this.cpShortName = cpShortName;
  }

  getMsoURL() {
    const URL = `${this.apiURL}/auth/${this.cpShortName}/mso.json`;
    return URL;
  }

    /**
   * Obtain MSO configuration options and IDP list
   *
   * @param {Object} options
   * @param {string} options.clientId
   * @returns {Promise}
   */
  obtainMsoConfig() {
    const URL = this.getMsoURL();
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    };
    return fetchData(URL, options, 3, 300);
  }

  getTADLoginStatus() {
    const URL = `${this.apiURL}/auth/${this.cpShortName}/status.json`;
    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8'
      },
    };
    return fetchData(URL, options, 3, 300);
  }

  getLoginURL({
    countryCode,
    idpShortName,
    returnURL
  }: {
    countryCode?: string,
    idpShortName: string,
    returnURL?: string
  }) {
    let URL = `${this.apiURL}/auth/${this.cpShortName}/login.html?idp=${idpShortName}`;
    if (returnURL) URL += `&return=${encodeURIComponent(returnURL)}`;
    if (countryCode) URL += `&country=${countryCode}`;
    return URL;
  }

  getLogout() {
    const URL = `${this.apiURL}/auth/${this.cpShortName}/logout.json`;
    const options = {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8'
      },
    };
    return fetchData(URL, options, 3, 300);
  }

  getOauth2LoginURL({
    countryCode,
    idpShortName,
    returnURL
  }: {
    countryCode?: string,
    idpShortName: string,
    returnURL?: string
  }) {
    let URL = `${this.apiURL}/auth/authorize?client_id=${this.cpShortName}&idp=${idpShortName}`;
    if (returnURL) URL += `&return=${encodeURIComponent(returnURL)}`;
    if (countryCode) URL += `&country=${countryCode}`;

    return URL;
  }
}

export default CloudpassService;
